import {
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogHeader,
  DialogRoot,
  DialogTitle,
  DialogTrigger,
} from "./ui/dialog.tsx";
import { Button } from "./ui/button.tsx";
import { useMutation } from "@tanstack/react-query";
import { Card } from "@chakra-ui/react";
import { Heading } from "@chakra-ui/react";
import { MdOutlineArrowOutward } from "react-icons/md";
import { api } from "../api/custom-api.ts";

type FileDialogProps = {
  label: string;
  files: Array<{
    id: string;
    file: {
      id: string;
      url: string;
    };
  }>;
  title: string;
};

type CardProps = {
  file: {
    id: string;
    file: {
      id: string;
      url: string;
    };
  };
};

const FileDialog = ({ label, files, title }: FileDialogProps) => {
  return (
    <DialogRoot size="cover" placement="center" motionPreset="slide-in-bottom">
      <DialogTrigger asChild>
        <Button
          size={"sm"}
          colorPalette={"black"}
          variant={"surface"}
          width={"28rem"}
          color={"#000000"}
          backgroundColor={"#ffffff"}
          borderColor={"#ffffff"}
          fontWeight={"600"}
          fontSize={"14px"}
          borderRadius={"0.5rem"}
        >
          {label}
        </Button>
      </DialogTrigger>
      <DialogContent className={"bg-white"}>
        <DialogHeader className={"flex flex-row justify-between items-center"}>
          <DialogTitle className={"text-black font-semibold text-[24px]"}>
            {title}
          </DialogTitle>
          <DialogCloseTrigger />
        </DialogHeader>
        <DialogBody>
          {files?.map((item) => <CardComponent file={item} />)}
        </DialogBody>
      </DialogContent>
    </DialogRoot>
  );
};

const CardComponent = ({ file }: CardProps) => {
  const { mutate } = useMutation({
    mutationFn: (url: string) => api.upload.getFileUrl({ url }),
    onSuccess: (response) => {
      window.open(response.url, "_blank");
    },
  });

  return (
    <Card.Root
      className={
        "border-[1px] border-solid border-[#334155] bg-[#334155] cursor-pointer mb-[1rem]"
      }
      variant={"outline"}
      size="md"
      onClick={() => mutate(file.file.url)}
    >
      <Card.Header
        className={"mb-[1.5rem] flex flex-row items-center justify-between"}
      >
        <Heading size="md" color={"#ffffff"}>
          {file.file.url}
        </Heading>
        <MdOutlineArrowOutward size={20} />
      </Card.Header>
    </Card.Root>
  );
};

export default FileDialog;
